import { IDefinicionAccionAuditoria } from './auditoria-acciones.interface';

/** Slug persistido en backend para el click en el menú lateral. */
export const ACCION_CLICK_MENU = 'click_menu';

/**
 * Concatena categoría y opción del menú con '->'.
 * Si no hay opción, solo la categoría.
 */
export function construirNombreAccion(
  p_nomCategoria: string,
  p_nomOpcion?: string
): string {
  const categoria = (p_nomCategoria || '').trim();
  const opcion = (p_nomOpcion || '').trim();

  if (categoria && opcion && categoria !== opcion) {
    return `${categoria} -> ${opcion}`;
  }

  return categoria || opcion;
}

/**
 * Catálogo de acciones auditables.
 */
export const DEFINICIONES_ACCIONES_AUDITORIA: Record<
  string,
  IDefinicionAccionAuditoria
> = {
  [ACCION_CLICK_MENU]: {
    slug: ACCION_CLICK_MENU,
    nombre: 'Click a menú',
  },
};

/**
 * Nombre visible de la acción. Si no está catalogada, se muestra el slug.
 */
export function obtenerNombreAccion(p_txtAccion: string): string {
  return DEFINICIONES_ACCIONES_AUDITORIA[p_txtAccion]?.nombre ?? p_txtAccion;
}
